import { render, staticRenderFns } from "./ThirdPartiesView.vue?vue&type=template&id=e0570420&"
import script from "./ThirdPartiesView.vue?vue&type=script&lang=js&"
export * from "./ThirdPartiesView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports